import { CompensationRollupType } from "@/types/analytics/analytics.employee.types.ts";
import { ApiWidgetMetric } from "@/types/reporting/reporting.types.ts";

export const SALARY_REPORT_METRICS = [
  ApiWidgetMetric.total_payroll,
  ApiWidgetMetric.average_salary,
  ApiWidgetMetric.median_salary,
  ApiWidgetMetric.total_bonus,
  ApiWidgetMetric.total_cost,
  ApiWidgetMetric.employer_contributions,
] as const;

export type SalaryReportMetric = (typeof SALARY_REPORT_METRICS)[number];

const TOTAL_COST_METRICS = new Set<ApiWidgetMetric>([
  ApiWidgetMetric.total_cost,
  ApiWidgetMetric.employer_contributions,
]);

export const getAvailableSalaryMetrics = (canViewTotalCost: boolean): SalaryReportMetric[] =>
  SALARY_REPORT_METRICS.filter((metric) => canViewTotalCost || !TOTAL_COST_METRICS.has(metric));

export const resolveSalaryMetric = (
  value: string | null,
  canViewTotalCost: boolean
): SalaryReportMetric =>
  getAvailableSalaryMetrics(canViewTotalCost).find((metric) => metric === value) ??
  ApiWidgetMetric.total_payroll;

export const getAvailableCompensationRollups = (canViewTotalCost: boolean) => [
  CompensationRollupType.gross,
  CompensationRollupType.net,
  ...(canViewTotalCost ? [CompensationRollupType.total_cost] : []),
];

export const resolveCompensationRollup = (
  value: string | null,
  canViewTotalCost: boolean
): CompensationRollupType =>
  getAvailableCompensationRollups(canViewTotalCost).find((rollup) => rollup === value) ??
  CompensationRollupType.gross;
